module.exports = __webpack_public_path__ + "files/9502bd4c0a9e08ab1baa7a9e8d35d00a.png";